export default __webpack_public_path__ + "static/media/Y13.8505fbe1.jpg";